export default "__VITE_ASSET__Dyav7PRe__"